/**
 * Monetization feature flags (monetization §11.7): literal constants that make the ABSENCE of payments explicit.
 * Nothing in the build imports a payment or ad SDK; these flags exist only so the absence is testable.
 */
export const FEATURE_FLAGS = Object.freeze({
  payments: false,
  ads: false,
  telemetryUpload: false,
  premiumTrack: false,
} as const);

export type FeatureFlags = typeof FEATURE_FLAGS;
